import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { injectIntl, intlShape } from 'react-intl'

import ROUTES from '../../constants/routing'

const LocalizedLink = ({ to, children, intl: { locale }, ...props }) => {
  let resolved = to
  if (ROUTES && Object.prototype.hasOwnProperty.call(ROUTES, to)) {
    resolved = ROUTES[to][locale] || ROUTES[to].en || ROUTES[to]
  }

  const href = (typeof resolved === 'string' ? resolved : String(resolved || '')).trim()

  const isExternal = /^https?:\/\//i.test(href)

  return isExternal ? (
    <a className={props.className} href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ) : (
    <Link {...props} to={`/${locale}/${href}`}>
      {children}
    </Link>
  )
}

LocalizedLink.propTypes = {
  to: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
}

export default injectIntl(LocalizedLink)